















































































































































































import { Mixins } from "vue-mixin-decorator";
import { Component } from "vue-property-decorator";
import { Action, Mutation, Getter } from "vuex-class";
import GeneralMixin from "@/mixin";
import { IImage } from "@/types/image";
import { ISite } from "@/types/site";
import CostChart from "@/components/user/CostChart.vue";
import { ChartData, ChartOptions } from "chart.js";
import { IAmountByCategory } from "@/types/amount_by_category";
import { ICost } from "@/types/cost";
import moment from "moment";

@Component({
  components: { CostChart }
})
export default class extends Mixins<GeneralMixin>(GeneralMixin) {
  @Action("site/get")
  public getSite!: (id: number) => void;

  @Action("site/amount")
  public getAmount!: (id: number) => void;

  @Action("site/updateCompletion")
  public updateCompletion!: (id: number) => void;

  @Action("image/getList")
  public getImageList!: (site_id: number) => boolean;

  @Action("site/amountByCategory")
  public getAmountByCategory!: (id: number) => void;

  @Action("site/updateInputCompleted")
  public updateInputCompleted!: (id: number) => Promise<void>;

  @Getter("site/single")
  public site!: ISite;

  @Getter("site/amount")
  public amount!: number;

  @Getter("image/list")
  public images!: IImage[];

  @Getter("site/byCategory")
  public amountByCategory!: IAmountByCategory[];

  @Mutation("site/clear")
  public clear!: () => void;

  @Mutation("image/clear")
  public clearImage!: () => void;

  public site_id = 0;
  public fab = false;

  public not_exist_cost = false;
  public open_graph = false;

  public async created() {
    this.clear();
    this.clearImage();
    this.site_id = Number(this.$route.params.site_id);

    await Promise.all([
      this.getSite(this.site_id),
      this.getAmount(this.site_id),
      this.getImageList(this.site_id),
      this.getAmountByCategory(this.site_id),
      this.dispGraph()
    ]);
    this.costExist();
  }

  public isImage(stage: number) {
    return !!this.images.find(image => image.stage_id === stage);
  }
  public chartOptions: ChartOptions = {
    maintainAspectRatio: false,
    tooltips: {
      enabled: false
    },
    legend: {
      //凡例
      display: false
    }
  };

  public dispGraph() {
    this.open_graph = true;
  }

  public costExist() {
    if (!this.site.cost) {
      return;
    }
    if (this.site.cost.length > 0) {
      this.not_exist_cost = false;
      setTimeout(this.dispGraph, 2000);
    } else {
      this.not_exist_cost = true;
    }
  }

  public async completionChange() {
    await this.updateCompletion(this.site_id);
  }

  public async inputCompletedChange() {
    await this.updateInputCompleted(this.site_id);
  }

  public chartData: ChartData = {
    // labels: this.labels,
    datasets: [
      {
        type: "doughnut",
        label: "経費内訳",
        // data: [],
        // backgroundColor: "rgb(255, 99, 132)",
        fill: false,
        lineTension: 0,
        // borderColor: "#f9a825",

        yAxisID: "1"
      }
    ]
  };

  public get dayCount() {
    const days: string[] = [];
    if (!this.site.cost) {
      return 0;
    }
    this.site.cost.forEach((cost: ICost) => {
      const day = moment(cost.accounted_at).format("YYYY-MM-DD");
      if (days.indexOf(day) < 0) {
        days.push(day);
      }
    });
    // 本日の入力がない場合は本日をカウントする
    const day = moment().format("YYYY-MM-DD");
    if (days.indexOf(day) < 0) {
      days.push(day);
    }

    return days.length;
  }
}
